import { CheckInput } from '@octano/global-ui';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { Card, Col, Container, Row } from 'reactstrap';
import GoBackButton from '../../../../../components/buttons/GoBackButton';
import { SectionTitle } from '../../../../../components/text';
import { PathsLayouts } from '../../../../../config/routes';
import { PeriodType } from '../../../../../types/PeriodType';
import CurriculumForm from '../CurriculumForm';
import { CurriculumLegend } from '../CurriculumLegend';
import CurriculumMentionList from '../CurriculumMentionList';
import CurriculumStudyPlanInfo from '../CurriculumStudyPlanInfo';
import { CurriculumDegreeActivitiesList } from '../parts/CurriculumDegreeActivities';
import { DegreeAverageOptions } from '../parts/DegreeAverageOptions';
import { DegreeDocuments } from '../parts/DegreeDocuments';

type PropsParams = {
  id: string;
  versionId: string;
};

const CurriculumCreate = () => {
  const prefix = 'studyPlans.curriculum';
  const readOnly: boolean = false;

  const history = useHistory();
  const { t } = useTranslation();
  const { id: studyPlanId, versionId } = useParams<PropsParams>();

  const [periodType, setPeriodType] = useState<PeriodType>();
  const [studyPlanName, setStudyPlanName] = useState<string>('');
  const [disabledEditButton, setDisabledEditButton] = useState<boolean>(false);
  const [hasMentions, setHasMentions] = useState(false);

  const goBack = useCallback(() => {
    history.push(
      `${PathsLayouts.academicOffers}/study-plans/record/${studyPlanId}`,
    );
  }, [history, studyPlanId]);

  return (
    <Container>
      <Card className="p-3 p-md-4">
        <Row>
          <Col xs={12} md={7}>
            <div className="mb-4">
              <GoBackButton onClick={goBack} />
            </div>
          </Col>
          <Col xs={12} md={5}>
            <CurriculumStudyPlanInfo
              id={studyPlanId}
              versionId={versionId}
              setStudyPlanName={setStudyPlanName}
              setPeriodType={setPeriodType}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12} md={12}>
            <SectionTitle text={t(`${prefix}.mentions`)} />
            <Row className="p-3">
              <span className="fs-20">{t(`${prefix}.hasMentions`)}</span>
            </Row>
            <Row className="p-3">
              <CheckInput
                label={t(`${prefix}.hasMentionsYes`)}
                name="hasMentions"
                value={hasMentions}
                onChange={() => setHasMentions(!hasMentions)}
              />
            </Row>
          </Col>
        </Row>

        <Row>
          <Col xs={12} md={12}>
            {!hasMentions ? (
              <CurriculumForm
                studyPlanName={studyPlanName}
                curriculumData={undefined}
                periodType={periodType}
                readOnly={readOnly}
                setDisabledEditButton={setDisabledEditButton}
                isMention={false}
                showSubmitButton={true}
                disabledSubmitButton={disabledEditButton}
                prefix={prefix}
              >
                {({ legend }) => (
                  <>
                    <Row>
                      <Col xs={{ size: 12 }}>
                        <CurriculumLegend legend={legend} />
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={{ size: 12 }}>
                        <DegreeAverageOptions readOnly={readOnly} />
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={{ size: 12 }}>
                        <CurriculumDegreeActivitiesList readOnly={readOnly} />
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={{ size: 12 }}>
                        <DegreeDocuments />
                      </Col>
                    </Row>
                  </>
                )}
              </CurriculumForm>
            ) : (
              <CurriculumMentionList />
            )}
          </Col>
        </Row>
      </Card>
    </Container>
  );
};

export default CurriculumCreate;
